// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roEldpEKDLQXyxceb55Y{justify-content:space-between;align-items:center;margin-bottom:12px;display:flex}.SGfeIn7d2GM8Bp9_pia0,._ut316yWE1o7WG5cTFuu{color:var(--content-primary-primary)}.L5_RXmvHC4nFGTIXHoEE{color:var(--content-primary-tertiary);margin-bottom:31px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `roEldpEKDLQXyxceb55Y`,
	"title__text": `SGfeIn7d2GM8Bp9_pia0`,
	"titleText": `SGfeIn7d2GM8Bp9_pia0`,
	"title__small": `_ut316yWE1o7WG5cTFuu`,
	"titleSmall": `_ut316yWE1o7WG5cTFuu`,
	"desc": `L5_RXmvHC4nFGTIXHoEE`
};
export default ___CSS_LOADER_EXPORT___;
